import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

const Form = () => {
  const data = [
    { name: 'birthday', type: 'date' },
    { name: 'checkBox', type: 'checkbox', required: true },
  ];
  const { register, handleSubmit, errors } = useForm();
  const [logText, setLogText] = useState('');
  return (
    <form className="form-test" onSubmit={handleSubmit(data => setLogText(JSON.stringify(data)))}>
      <div className="Customer-title">客戶資訊</div>
        <div className="customer">
          <div className="formInput">
            <div>example</div>
            <input className="formInput__textInput" name={`example${key}`} defaultValue={data[0].name} placeholder="姓名" ref={register} />
          </div>
          <div className="formInput">
            <div>exampleRequired</div>
            <input className="formInput__textInput" name="exampleRequired" ref={register({ required: true, pattern: /[A-Za-z]/ })} />
            {/* errors will return when field validation fails  */}
            {errors.exampleRequired?.type === 'required' && <div className="formInput__error">This field is required</div>}
            {errors.exampleRequired?.type === 'pattern' && <div className="formInput__error">English only</div>}
          </div>
        </div>
      <div className="customer">
        {data.map(field => (
          <div className="formInput">
            <div>{field.name}</div>
            {field.type === 'date' && <input name={field.name} className="formInput__textInput" type="date" ref={register} />}
            {field.type === 'checkbox' && <input name={field.name} className="formInput__textInput" type="checkbox" ref={register({ required: field.required })} />}
            {errors[field.name]?.type === 'required' && <div className="formInput__error">This field is required</div>}
          </div>
        ))}
      </div>
      <input type="submit" />
      <div>submit{logText}</div>
    </form>
  );
}

export default Form;